import React from 'react';
import { usePathParam } from '@atlassian/jira-platform-router-utils';
import { ProjectContextProvider } from '@atlassian/jira-providers-project-context';
import { useIsItsmTemplateProject } from '@atlassian/jira-router-resources-service-desk-is-itsm-project';
import { AsyncIncidentManagementTourQueues } from '@atlassian/jira-servicedesk-incident-management-tour/src/async';
import { SHORT_FORM_INCIDENTS } from '@atlassian/jira-servicedesk-work-category';
import type { ProjectId } from '@atlassian/jira-shared-types';

export type Props = {
	projectId: ProjectId;
};

export const IncidentManagementTour = (props: Props) => {
	const [practiceType] = usePathParam('practiceType');
	const { data: isItsmProject } = useIsItsmTemplateProject();
	if (isItsmProject !== true) {
		return null;
	}
	return practiceType === SHORT_FORM_INCIDENTS ? (
		<ProjectContextProvider>
			{({ data }) =>
				// @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
				data && data.isProjectAdmin === true ? (
					<AsyncIncidentManagementTourQueues {...props} />
				) : null
			}
		</ProjectContextProvider>
	) : null;
};
